import React from 'react';
import { Link } from 'react-router-dom';
import './ProgramPage.css';

const DataScienceAI = () => {
  return (
    <div className="program-page">
      <section className="program-hero program-hero--red">
        <div className="container">
          <h1>Data Science and AI Course with Industry-Oriented Training</h1>
          <p className="hero-description">
            Our data science and AI course helps learners understand machine learning, statistics, and AI-driven decision making using real-world business problems.
          </p>
        </div>
      </section>

      <section className="program-details section">
        <div className="container">
          <h2 className="section-title">Key Details</h2>
          <div className="details-grid">
            <div className="detail-card">
              <div className="detail-icon">🐍</div>
              <h3>Python for Data Science</h3>
              <p>Advanced Python for data manipulation and analysis</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">📊</div>
              <h3>Statistics and Probability</h3>
              <p>Statistical foundations for data science</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">🤖</div>
              <h3>Machine Learning Fundamentals</h3>
              <p>Supervised and unsupervised learning algorithms</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">🧠</div>
              <h3>AI Use Cases</h3>
              <p>Real-world applications of artificial intelligence</p>\n            </div>
            <div className="detail-card">
              <div className="detail-icon">🏆</div>
              <h3>Capstone Projects</h3>
              <p>End-to-end projects showcasing your expertise</p>
            </div>
          </div>
        </div>
      </section>

      <section className="program-cta section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Master Data Science & AI?</h2>
            <p>Join our upcoming batch and build AI-driven solutions</p>
            <Link to="/apply" className="btn btn-primary btn-large">
              Apply for Data Science & AI Program
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataScienceAI;
